module.exports = __webpack_public_path__ + "img/resourceAssign.c97f900c.svg";